export default __webpack_public_path__ + "static/media/spinning_cadense_01.228c4e25.mp4";